const SET_DIRECTORY_FOLDERS = 'SET_DIRECTORY_FOLDERS';
const SET_INNER_FILES = 'SET_INNER_FILES';
const SET_SECRET_FILES = 'SET_SECRET_FILES';

export { SET_DIRECTORY_FOLDERS, SET_INNER_FILES, SET_SECRET_FILES };
